export default "__VITE_ASSET__Baz34Oz9__"